import {
  AutocompleteActionsUnion,
  AutocompleteActionTypes
} from '@core/actions/autocomplete.actions';

export interface State {
  productTripDates: string[];
  productCountryTypes: string[];
  productBusinessUnits: string[];
  productSeasons: string[];
  productQualities: string[];
  productCollections: string[];
  productTags: string[];
}
export const INITIAL_STATE: State = {
  productTripDates: [],
  productCountryTypes: [],
  productBusinessUnits: [],
  productSeasons: [],
  productQualities: [],
  productCollections: [],
  productTags: [],
};

const mapRoutes = {
  'products/season': 'productSeasons',
  'products/metadata.quality': 'productQualities',
  'products/metadata.tripDate': 'productTripDates',
  'products/metadata.collection': 'productCollections',
  'products/tags': 'productTags',
  // 'products/countryType': 'productCountryTypes',
  // 'products/businessUnit': 'productBusinessUnits',
  'products/descriptionColor': 'descriptionColor',
  'products/articleGroupName': 'articleGroupName',
  'products/metadata.productType': 'productType'
};

export function reducer(
  state: State = INITIAL_STATE,
  action: AutocompleteActionsUnion
) {
  switch (action.type) {
    case AutocompleteActionTypes.LoadSingleSuccess:
      return {
        ...state,
        [mapRoutes[action.route]]: action.results.filter(item => !!item)
      };

    default:
      return state;
  }
}

export const selectProductTripDates = (state: State) => state.productTripDates;
// export const selectProductCountryTypes = (state: State) =>
//   state.productCountryTypes;
// export const selectProductBusinessUnits = (state: State) =>
//   state.productBusinessUnits;
export const selectProductSeasons = (state: State) => state.productSeasons;
export const selectProductQualities = (state: State) => state.productQualities;
export const selectProductCollections = (state: State) => state.productCollections;
export const selectProductTags = (state: State) => state.productTags;
